import {
  NodeUpdateManyMut,
  NodeCreateManyMut,
  NodeDeleteManyMut,
  WizardDeleteMut,
  ProcessNodesMut,
} from "api/mutations";
import type { UpdateNode } from "interfaces/schemas";
import { enqueue } from "stores/requestQueueStore";
import type { Project } from "stores/project/project/projectStore";
import type { NodeRequestItem } from "./createNodeInput";

type Action = {
  action: "CREATE" | "DELETE" | "UPDATE";
  nodes: NodeRequestItem[];
};

export const updateNodes = (
  nodes: UpdateNode[],
  project: Project,
  language: string,
) =>
  enqueue({
    query: NodeUpdateManyMut,
    variables: {
      input: {
        projectId: project?.id,
        languageCode: language,
        nodes,
      },
    },
  });

export const createNodes = (
  nodes: Node[],
  project: Project,
  language: string,
) =>
  enqueue({
    query: NodeCreateManyMut,
    variables: {
      input: { projectId: project?.id, languageCode: language, nodes },
    },
  });

export const deleteNodes = (
  ids: string[],
  project: Project,
  language: string,
) =>
  enqueue({
    query: NodeDeleteManyMut,
    variables: {
      input: { projectId: project?.id, languageCode: language, ids },
    },
  });

export const deleteWizard = (
  nodeId: string,
  project: Project,
  language: string,
) =>
  enqueue({
    query: WizardDeleteMut,
    variables: {
      input: { projectId: project?.id, languageCode: language, nodeId },
    },
  });

export const processNodes = (
  actions: Action[],
  project: Project,
  language: string,
) =>
  enqueue({
    query: ProcessNodesMut,
    variables: {
      input: {
        projectId: project?.id,
        languageCode: language,
        actions,
      },
    },
  });
